import { FC } from 'react'
import { FLOWCODE_MARKETING_BASE_URL, Routes } from '@dtx-company/true-common/src/constants/routes'
import { GetServerSideProps } from 'next'
import { PageContainer } from '../components/layout'
import { TeamContainerProps } from '@app/code/src/containers/team/Team.types'
import { getTeamData } from '../utils/aboutus'
import { removeTrailingSlash } from '@app/common/src/hooks/useCanonicalURL'
import { setWebPageCacheControl } from '../utils/cache'
import { useRedirectOnAuthChanges } from '@dtx-company/inter-app/src/hooks/auth/useRedirectOnAuthChanges'
import dynamic from 'next/dynamic'

/* istanbul ignore next */
const TeamContainer = dynamic<TeamContainerProps>(() =>
  import('@app/code/src/containers/team').then(mod => mod.TeamContainer)
)
const canonical = `${removeTrailingSlash(FLOWCODE_MARKETING_BASE_URL)}${Routes.TEAM}`

const Team: FC<TeamContainerProps> = props => {
  useRedirectOnAuthChanges()

  return (
    <PageContainer
      page={Routes.TEAM}
      disableNotifications
      disableSideNav
      injectedMeta={{ canonical }}
    >
      <TeamContainer data={props.data} />
    </PageContainer>
  )
}

export const getServerSideProps: GetServerSideProps<TeamContainerProps> = async ({ res }) => {
  const data = await getTeamData()

  setWebPageCacheControl(res, 300)

  return {
    props: {
      data
    }
  }
}

export default Team
